import { apiV2 } from "@/store";

const actions = {
  getAllLeads: () => {
    return new Promise((resolve, reject) => {
      apiV2.get(`/leads`, {
        params: {
          select: [
            "customer_first_name",
            "customer_last_name",
            "customer_email",
            "customer_phone",
            "move_in_date",
            "unit_dimensions",
            "quoted_price",
            "concession_id",
            "created_at",
            "waiting_list_id",
            "tenant_id",
            "rented_online",
            "unit_id",
            "facility_id"
          ],
          with: [
            "facility:id,location_code,name,street_address,city,state,postal_code,phone",
            "facility.promotions"
          ]
        }
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getAllFollowups: () => {
    return new Promise((resolve, reject) => {
      apiV2.get(`/followups`, {
        params: {
          with: ["facility:id,location_code"]
        }
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

export default {
  actions
};
